import 'index.css';

import { lazy } from 'react';
import { runWithAuth } from '@da-voxel-toolkits-appdev/core';

const App = lazy(() => import('./App'));
runWithAuth(App, 'root');
